import styled from '@emotion/styled'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { breakpoint } from '../../__styling/style-functions'
import { colors } from '../../__styling/settings/colors'
import { fonts } from '../../__styling'

export const StyledNewsTipsContainer = styled.div({
    width: '100%',
    padding: `${calcRem(24)} 0`,
})

export const StyledNewsTipsHeading = styled.h3({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(20),
    fontWeight: 700,
    color: colors.black,
    margin: `0 0 ${calcRem(4)} 0`,

    [breakpoint('sm')]: {
        fontSize: calcRem(22),
    },
})

export const StyledNewsTipsDescription = styled.p({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(14),
    fontWeight: 400,
    color: colors.black,
    margin: `0 0 ${calcRem(16)} 0`,
    lineHeight: 1.5,
})

export const StyledForm = styled.form({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(12),
    width: '100%',
})

export const StyledLabel = styled.label({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(14),
    fontWeight: 600,
    color: colors.black,
    display: 'block',
    marginBottom: calcRem(4),
})

export const StyledInput = styled.input({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(14),
    padding: `${calcRem(10)} ${calcRem(12)}`,
    border: `1px solid #ccc`,
    borderRadius: calcRem(4),
    width: '100%',
    boxSizing: 'border-box',
    lineHeight: 1.5,
    color: colors.black,
    backgroundColor: colors.white,

    '&:focus': {
        outline: `2px solid ${colors.sevennews.red}`,
        outlineOffset: '-1px',
    },

    '&::placeholder': {
        color: '#999',
    },
})

export const StyledSelect = styled.select({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(14),
    padding: `${calcRem(10)} ${calcRem(12)}`,
    border: `1px solid #ccc`,
    borderRadius: calcRem(4),
    width: '100%',
    boxSizing: 'border-box',
    lineHeight: 1.5,
    color: colors.black,
    backgroundColor: colors.white,

    '&:focus': {
        outline: `2px solid ${colors.sevennews.red}`,
        outlineOffset: '-1px',
    },
})

export const StyledTextarea = styled.textarea({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(14),
    padding: `${calcRem(10)} ${calcRem(12)}`,
    border: `1px solid #ccc`,
    borderRadius: calcRem(4),
    width: '100%',
    boxSizing: 'border-box',
    lineHeight: 1.5,
    color: colors.black,
    backgroundColor: colors.white,
    minHeight: calcRem(120),
    resize: 'vertical',

    '&:focus': {
        outline: `2px solid ${colors.sevennews.red}`,
        outlineOffset: '-1px',
    },

    '&::placeholder': {
        color: '#999',
    },
})

export const StyledFieldGroup = styled.div({
    display: 'flex',
    flexDirection: 'column',
})

export const StyledCheckboxGroup = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: calcRem(8),
})

export const StyledCheckboxInput = styled.input({
    width: calcRem(18),
    height: calcRem(18),
    margin: 0,
})

export const StyledCheckboxLabel = styled.label({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(14),
    fontWeight: 400,
    color: colors.black,
    lineHeight: 1.5,
})

export const StyledSubmitButton = styled.button({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(14),
    fontWeight: 700,
    padding: `${calcRem(12)} ${calcRem(24)}`,
    border: 'none',
    borderRadius: calcRem(4),
    color: colors.white,
    backgroundColor: colors.sevennews.red,
    cursor: 'pointer',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    alignSelf: 'flex-start',
    transition: 'background-color 0.2s ease',

    '&:hover': {
        backgroundColor: colors.sevennews.darkRed,
    },

    '&:focus': {
        outline: `2px solid ${colors.sevennews.red}`,
        outlineOffset: '2px',
    },

    '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed',
        pointerEvents: 'none',
    },
})

export const StyledStatusMessage = styled.p<{ variant: 'success' | 'error' }>(
    ({ variant }) => ({
        fontFamily: fonts.sevennews.sansSerif,
        fontSize: calcRem(14),
        fontWeight: 500,
        lineHeight: 1.5,
        padding: `${calcRem(12)} ${calcRem(16)}`,
        borderRadius: calcRem(4),
        margin: 0,
        color: variant === 'success' ? '#155724' : '#721c24',
        backgroundColor: variant === 'success' ? '#d4edda' : '#f8d7da',
        border: `1px solid ${variant === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
    }),
)

export const StyledHoneypot = styled.div({
    position: 'absolute',
    left: '-9999px',
    opacity: 0,
    height: 0,
    overflow: 'hidden',
})

export const StyledFieldError = styled.span({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(12),
    fontWeight: 500,
    color: '#721c24',
    marginTop: calcRem(4),
})

export const StyledTerms = styled.span({
    fontFamily: fonts.sevennews.sansSerif,
    fontSize: calcRem(12),
    color: '#666',
    lineHeight: 1.5,

    a: {
        color: colors.sevennews.toreaBay,
        textDecoration: 'underline',
    },
})

export const StyledPrivacyDisclosure = StyledTerms
